/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Anagrafica } from './anagrafica';
import { Comune } from './comune';
import { Scuola } from './scuola';
import { UserType } from './userType';

export interface User { 
    id?: string;
    userType?: UserType;
    email?: string;
    nome?: string;
    cognome?: string;
    keycloakSubjectId?: string;
    codiceFiscaleHash?: string;
    creationDate?: Date;
    expires?: number;
    accountExpired: boolean;
    accountEnabled: boolean;
    kcRolePending?: boolean;
    anagrafiche?: Array<Anagrafica>;
    scuoleGestite?: Array<Scuola>;
    comuniGestiti?: Array<Comune>;
    fullname?: string;
}